module.exports = __webpack_public_path__ + "static/media/5_sukupuolten-tasa-arvo.31498929.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/5_sukupuolten-tasa-arvo.svg
// module id = ./src/images/agendaIcons/5_sukupuolten-tasa-arvo.svg
// module chunks = 1